import EmailConfirmed from "../../../../modules/Account/components/EmailConfirmed";
import { closeMobileSliderPageAction } from "../../../mobileAppActions";
import { connect } from "react-redux";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader";
import React from "react";

function SlideMobileEmailConfirmed(props) {
    const {closeMobileSliderPage} = props;

    return <div className="d-flex flex-column px-3 h-100">
            <MobileSliderPagesHeader/>
            <div className="flex-1 d-flex justify-content-center align-items-center flex-column pb-5 mb-5">
                <EmailConfirmed handleButtonClick={closeMobileSliderPage}/>
            </div>
        </div>
}
const mapDispatchToProps = (dispatch) => ({
    closeMobileSliderPage: (payload) => dispatch(closeMobileSliderPageAction(payload)),
});


export default connect(null, mapDispatchToProps)(SlideMobileEmailConfirmed);
